import CONSTANTES from '../constantes';
import { takeEvery, call, put} from 'redux-saga/effects'
import {message} from 'antd'
import { actionPutClientes, actionPutCliente, actionPutDetailCliente, actionAddCliente } from '../acciones/accionesClientes';
const axios = require('axios');

const getClientes = (status) => fetch(`${CONSTANTES.URL_API}/panel/clienteslista/`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => { 
  })

const filterClientes = (busqueda) => fetch(`${CONSTANTES.URL_API}/panel/clienteslista/?busqueda=${busqueda}`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => { 
  })

  function* sagasGetClientes(values) {
    try {
      if (values.filter) {
        let clientes = yield call(filterClientes, values.filter);
        if (clientes) {
          yield put(actionPutClientes(clientes))
        }
      }
      else {
        let clientes = yield call(getClientes);
        if (clientes) {
          yield put(actionPutClientes(clientes))
        }
      }
      
  
    } catch (error) {
  
      console.log(error)
    }
  }


  const getCliente = (codigoCliente) => fetch(`${CONSTANTES.URL_API}/panel/clientesdetalle/${codigoCliente}/`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
  })


function* sagasDetailCliente(values) {
    try {
      //let token = localStorage.getItem('userToken');
      let codigoCliente=values.idCliente
      let detail = yield call(getCliente, codigoCliente);
      if (detail) {
        yield put(actionPutDetailCliente(detail))
      }
    } catch (error) {
  
      console.log(error)
    }
  }
  // const registroCliente = (datos) => fetch(`${CONSTANTES.URL_API}/panel/clienteslista/`,
  // {
  //   method: 'POST',
  //   body: JSON.stringify(datos),
  //   headers: new Headers({
  //     'Content-Type': 'application/json'
  //   })
  // })
  // .then(response => {
  //   return response.json()
  // })
  // .catch(e => {
  //   console.log(e)
  // })

  const registroCliente = (datos) =>axios({
    method: 'POST',
    url: `${CONSTANTES.URL_API}/panel/clienteslista/`,
    data:JSON.stringify(datos),
    headers: {
        'Content-Type': 'application/json'
    }
  })
  .then(function (response) {
    return response
  })
  .catch(error=>  {
    return error.response
  });
  

function* sagasRegistrarCliente(values) {
    try {
      let datoCliente=values.values
      const cliente = yield call(registroCliente, datoCliente);
      console.log(cliente.data)
      if (cliente.status!==400) {
        message.success("Cliente registrado");
        yield put(actionAddCliente({CODIGO:cliente.data.CODIGO, NOMBRE:cliente.data.NOMBRE}))
      }
  
    } catch (error) {
      console.log(error)
      message.error("Error al registrar cliente");
    }
  }

  const editarCliente=(idCliente,cliente)=> fetch(`${CONSTANTES.URL_API}/panel/clienteslista/${idCliente}/`,
{
  method: 'PUT',
  body:JSON.stringify(cliente),
  headers: new Headers({
    'Content-Type': 'application/json'
})
})
.then(response=>{
    return response.json()
  })
  .catch(e=>{
    console.log(e)
  })

  function* sagasEditarCliente(values) {
    try {
      let clienteEdit=yield call(editarCliente, values.idCliente, values.values)
      //let detailCliente=yield call(editarCliente, values.idCliente, cliente)
      if(clienteEdit){
        let cliente = yield call(getCliente, clienteEdit.CODIGO);
        if (cliente) {
          yield put(actionPutCliente(clienteEdit))
          yield put(actionPutDetailCliente(cliente)) 
        }
        message.success("Cliente editado");
      } 
      else{
       message.error("Error al editar Cliente");
      }
     
    } catch (error) {
      console.log(error)
    }
  }

export default function* SagasClientes() {
    yield takeEvery(CONSTANTES.GET_CLIENTES, sagasGetClientes)
    yield takeEvery(CONSTANTES.GET_DETAIL_CLIENTE, sagasDetailCliente)
    yield takeEvery(CONSTANTES.REGISTRO_CLIENTE, sagasRegistrarCliente)
    yield takeEvery(CONSTANTES.EDITAR_CLIENTE, sagasEditarCliente)
  }